// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__18fIE"};